import { Spin } from 'antd';
import { Suspense, lazy } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import Layout from '../../../components/Layout';
import Menu from '../../../components/Layout/Menu';

const AdminsProfileContent = lazy(() => import('../../../components/Pages/Admins/[adminId]'));

export default function AdminsProfile(): JSX.Element {
  document.title = `${process.env.REACT_APP_TITLE}: Admin Profile`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <Suspense fallback={<Spin spinning indicator={<LoadingOutlined spin />} />}>
        <AdminsProfileContent />
      </Suspense>
    </Layout>
  );
}
